import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaLink } from "react-icons/fa";
import { GrInstagram } from "react-icons/gr";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import LanguageContext from '../../contexts/language';

import Base from '../../assets/images/base-square.png';

export default function Home() {

    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    const [index, setIndex] = useState(-1);
    const images = Array.from({ length: 62 }, (_, i) => ({
        src: require(`../../assets/event/photo_event_${i + 1}.jpg`)
    }));

    return (
        <div className="page">
            <Header />
            <div className="mt-60 mb-60">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 m-auto">
                            {lang==='pt' ?
                            <div className="text text-left box-feature">
                                <p className="mb-40">Lideranças, autoridades públicas e especialistas se reuniram para o evento <strong>Crianças e ação climática: prioridades e compromissos rumo à COP30</strong> com objetivo de fomentar o diálogo e iniciativas sobre adaptação climática e infâncias. O encontro foi promovido pelo Alana, Pontifical Academy of Science (PAS) e da Pontifical Academy of Social Science (PASS) e com parceria da Presidência da COP30.</p>
                                <p className="fs-4 mb-0">
                                    <strong>Materiais<br />Assista aos painéis</strong>
                                </p>
                                <p>Toda a programação das do evento pode ser conferida na íntegra a seguir:</p>
                                <div className="d-btn mt-10 mb-40">
                                    <Link to="/assistir" className="btn-send text-uppercase">Assista Aqui</Link>
                                </div>

                                <p className="fs-4 mb-0">
                                    <strong>Síntese das discussões</strong>
                                </p>
                                <p>Resentantes da Pontifical Academy of Science (PAS) e da Pontifical Academy of Social Science (PASS) prepararam uma síntese com destaque do evento e do contexto climático local para ser discutido no encontro global que acontecerá em 2027 no Vaticano. </p>
                                <p className="mb-40">Para saber mais, <a class="link" href="#">acesse aqui</a>.</p>


                                <p className="fs-4 mb-0">
                                    <strong>Fotos do Evento</strong>
                                </p>
                                <div className="mb-40">
                                    <div className="row">
                                        {images.map((img, i) => (
                                        <div className="col-md-3 p-1" key={i}>
                                            <img
                                                src={Base}
                                                className="img-fluid shadow rounded bg-cover"
                                                onClick={() => setIndex(i)}
                                                style={{backgroundImage: `url(${img.src})`, cursor: "pointer"}}
                                            />
                                        </div>))}
                                    </div>
                                </div>

                                <p className="fs-4 mb-0">
                                    <strong>Conheça e acompanhe a nossa atuação:</strong>
                                </p>
                                <div className="d-inline-flex align-items-center gap-3 pt-2">
                                    <a class="btn-send-inverted d-inline-flex align-items-center gap-2" href="https://www.instagram.com/institutoalana/" target="_blank">
                                        <GrInstagram size={22} />
                                        <span>institutoalana</span>
                                    </a>
                                    <a class="btn-send-inverted d-inline-flex align-items-center gap-2" href="https://www.linkedin.com/company/instituto-alana/" target="_blank">
                                        <FaLinkedinIn size={22} />
                                        <span>Instituto Alana</span>
                                    </a>
                                    <a class="btn-send-inverted d-inline-flex align-items-center gap-2" href="https://alana.org.br" target="_blank">
                                        <FaLink size={22} />
                                        <span>alana.org.br</span>
                                    </a>
                                </div>
                            </div>:
                            <div className="text text-left box-feature">
                                <p className="mb-40">Leaders, public authorities, and experts convened for the event <strong>Children and Climate Action: Priorities and Commitments Towards COP30</strong> , with the purpose of advancing dialogue and strengthening initiatives focused on climate adaptation and childhood. The meeting was organized by Alana, the Pontifical Academy of Sciences (PAS), and the Pontifical Academy of Social Sciences (PASS), in partnership with the COP30 Presidency.</p>
                                <p className="fs-4 mb-0">
                                    <strong>Materials<br />Watch the panels</strong>
                                </p>
                                <p>The full program of the event can be accessed in its entirety below:</p>
                                <div className="d-btn mt-10 mb-40">
                                    <Link to="/assistir" className="btn-send text-uppercase">Watch Here</Link>
                                </div>

                                <p className="fs-4 mb-0">
                                    <strong>Summary of the Discussions</strong>
                                </p>
                                <p>Representatives from the Pontifical Academy of Sciences (PAS) and the Pontifical Academy of Social Sciences (PASS) prepared a summary highlighting the event and the local climate context, to be discussed at the global meeting that will take place in 2027 at the Vatican.</p>
                                <p className="mb-40">For more information, <a class="link" href="#">click here</a>.</p>


                                <p className="fs-4 mb-0">
                                    <strong>Event photos</strong>
                                </p>
                                <div className="mb-40">
                                    <div className="row">
                                        {images.map((img, i) => (
                                        <div className="col-md-3 p-1" key={i}>
                                            <img
                                                src={Base}
                                                className="img-fluid shadow rounded bg-cover"
                                                onClick={() => setIndex(i)}
                                                style={{backgroundImage: `url(${img.src})`, cursor: "pointer"}}
                                            />
                                        </div>))}
                                    </div>
                                </div>

                                <p className="fs-4 mb-0">
                                    <strong>Learn more and follow our work:</strong>
                                </p>
                                <div className="d-inline-flex align-items-center gap-3 pt-2">
                                    <a class="btn-send-inverted d-inline-flex align-items-center gap-2" href="https://www.instagram.com/institutoalana/" target="_blank">
                                        <GrInstagram size={22} />
                                        <span>institutoalana</span>
                                    </a>
                                    <a class="btn-send-inverted d-inline-flex align-items-center gap-2" href="https://www.linkedin.com/company/instituto-alana/" target="_blank">
                                        <FaLinkedinIn size={22} />
                                        <span>Instituto Alana</span>
                                    </a>
                                    <a class="btn-send-inverted d-inline-flex align-items-center gap-2" href="https://alana.org.br" target="_blank">
                                        <FaLink size={22} />
                                        <span>alana.org.br</span>
                                    </a>
                                </div>
                            </div>}
                            
                        </div>
                    </div>
                </div>
            </div>
            <Lightbox
                index={index}
                open={index >= 0}
                close={() => setIndex(-1)}
                slides={images}
            />
            <Footer />
        </div>
    );
}
